import Mediator from './Mediator';
const baseUrl = 'https://flashcardapi.fatfx.com/api/v1';
const validDeckIdTest = (id) => (/^[0-9a-z]{24}$/i).test(id);

let createFetchBuilder = () => {
    let currentToken = null;

    const doFetch = (...args) => {
        let [ url, init={}, isLoginRequest=false ] = args;

        let headers = Object.assign({}, init.headers || {}, {'Content-Type': 'application/json', 'X-Token': currentToken});
        let params = Object.assign({}, init, { credentials: 'include', headers });

        function deferredFetch(...args) {
            return new Promise(resolve => {
                Mediator.broadcast('ConnectionTimeout', () => doFetch(...args).then(response => resolve(response)));
            });
        }

        return fetch(`${baseUrl}${url}`, params)
        .then(response => {
            let { headers, status } = response;

            return response.json()
            .then(body => {
                currentToken = headers.get('X-Token');

                if (status === 401 && !isLoginRequest && body.error === 'Connection has expired') return deferredFetch(...args);

                return body;
            });
        })
    };


    return doFetch;
};

let buildFetch = createFetchBuilder();

export function login(code) {
    if (typeof code !== 'string' || !code.trim()) return Promise.reject(new Error(`Invalid code: '${code}'`));

    return buildFetch('/remote/connection', {method: 'PUT', body: JSON.stringify({ code })}, true)
    .then(({error, handle, language}) => ({error, handle, language, loggedIn: !error}))
    .catch(() => ({ loggedIn: false }));
};

export function reconnect() {
    return buildFetch('/remote/revive', {method: 'PUT'}, true)
    .then(({error, handle, language}) => ({
        error,
        handle,
        language,
        loggedIn: !error
    }))
    .catch(error => ({ error, loggedIn: false }));
}

export function logout() {
    return buildFetch('/remote/connection', {method: 'DELETE'});
}

export function getDeckList() {
    return buildFetch('/remote/decks')
    .catch(err => console.log(err))
    .then(decks => {
        let { error } = decks;

        if (error) {
            Mediator.broadcast('ConnectionError');
            return Promise.reject(new Error(error));
        }

        return decks;
    });
}
export function getDeckById(id) {
    if (validDeckIdTest(id)) return buildFetch(`/remote/decks/${id}`)
    .then(deck => {
        let { error, cards } = deck;

        if (error) {
            Mediator.broadcast('ConnectionError');
            return Promise.reject(new Error(error));
        }

        cards = (cards || []).map(card => {
            let values = card.values.map(value => value || '');
            return Object.assign({}, card, { values: [...values, '', '', '', ''].slice(0, 4) });
        });

        return Object.assign(deck, { cards });
    });

    return Promise.reject(new Error('Invalid ID'));
}
export function saveDeck (deck) {
    let { id } = deck;
    let url;
    let method;
    if (id) {
        url = `/remote/decks/${ id }`;
        method = 'PUT';
    } else {
        url = '/remote/decks';
        method = 'POST';
    }

    return buildFetch(url, { method, body: JSON.stringify(deck) })
    .then(deck => {
        Mediator.broadcast('DeckListRequiresUpdate');
        return deck;
    });
}
export function suggestLanguage(baseLanguage, hint) {
    if (typeof baseLanguage !== 'string' || !baseLanguage.trim()) return Promise.resolve([]);
    if (typeof hint !== 'string' || !hint.trim()) return Promise.resolve([]);

    return buildFetch(`/remote/languages/${baseLanguage}/suggest/${hint}`);
}

export function getLanguage(baseLanguage) {
    return buildFetch(`/languages/${baseLanguage}`);
}



// WEBPACK FOOTER //
// ./src/services/APIAgent.js